/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  getI64Decoder,
  getI64Encoder,
  getStructDecoder,
  getStructEncoder,
  getU32Decoder,
  getU32Encoder,
  getU64Decoder,
  getU64Encoder,
  type FixedSizeCodec,
  type FixedSizeDecoder,
  type FixedSizeEncoder,
} from "@solana/kit";
import {
  getReputationSourceTypeDecoder,
  getReputationSourceTypeEncoder,
  type ReputationSourceType,
  type ReputationSourceTypeArgs,
} from ".";

/** Reputation component for multi-source Ghost Score */
export type ReputationComponent = {
  sourceType: ReputationSourceType;
  score: bigint;
  weight: number;
  lastUpdated: bigint;
  dataPoints: bigint;
};

export type ReputationComponentArgs = {
  sourceType: ReputationSourceTypeArgs;
  score: number | bigint;
  weight: number;
  lastUpdated: number | bigint;
  dataPoints: number | bigint;
};

export function getReputationComponentEncoder(): FixedSizeEncoder<ReputationComponentArgs> {
  return getStructEncoder([
    ["sourceType", getReputationSourceTypeEncoder()],
    ["score", getU64Encoder()],
    ["weight", getU32Encoder()],
    ["lastUpdated", getI64Encoder()],
    ["dataPoints", getU64Encoder()],
  ]);
}

export function getReputationComponentDecoder(): FixedSizeDecoder<ReputationComponent> {
  return getStructDecoder([
    ["sourceType", getReputationSourceTypeDecoder()],
    ["score", getU64Decoder()],
    ["weight", getU32Decoder()],
    ["lastUpdated", getI64Decoder()],
    ["dataPoints", getU64Decoder()],
  ]);
}

export function getReputationComponentCodec(): FixedSizeCodec<
  ReputationComponentArgs,
  ReputationComponent
> {
  return combineCodec(
    getReputationComponentEncoder(),
    getReputationComponentDecoder(),
  );
}
